module.exports = "https://cdn.hellotech.com/client-assets/printers_desktop_6e126b2f96d765763c2c2eaae0686aa3.png";